export const BLUR = 'checkout/contacts/BLUR';
export const blur = (path: string) => ({
  type: BLUR,
  path,
});
